import React, { Suspense } from 'react';
import { connect, Provider } from 'react-redux';
import * as actions from '../../../redux/projects/actions.projects';
import phraseTypes from '../../../const/phraseTypes';
import formats from '../../../const/formats';
import moment from 'moment';
import _ from 'lodash';
import logLevels from '../../../const/logLevels';
import getResourceLink from '../../../services/mini/getResourceLink';
import { isJsonLogType } from '../../../services/mini/isJsonLogType';
import cancelEvent from '../../../services/mini/cancelEvent';
import getContentWithChunks from '../../../services/mini/getContentWithChunks';
import getEntityAttrsFromChunk from '../../../services/mini/getEntityAttrsFromChunk';
import escapeHtml from '../../../services/mini/escapeHtml';
import PlayIntentAudioButton from '../PlayIntentAudioButton/PlayIntentAudioButton';
import getScoreColor from '../../../services/mini/getScoreColor';
import { confirmAlert } from '../../../services/mini/alanConfirmAlert';
import store from '../../../store';
import projectHelper from '../../../services/ProjectHelper';
import { isShowOpGraph } from './logHelper';
import { DislikeIcon, LikeIcon, OpGraphLogIcon } from './logIcons';
import { Loader, LoaderSize, LoaderTheme } from '../Loader/Loader';

const LogGraphPopup = React.lazy(() => import('./LogGraphPopup/LogGraphPopup'));

class LogLineRow extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        let curProps = this.props;

        if (curProps.log && nextProps.log && curProps.log.id !== nextProps.log.id) {
            return true;
        }

        return curProps.isNew !== nextProps.isNew;
    }

    onLogLineClick = (e) => {
        const clickedChucnkEl = e.target.closest("[data-filter-key]");
        if (clickedChucnkEl) {
            const { filterKey, filterValue } = getEntityAttrsFromChunk(clickedChucnkEl);
            if (filterKey && filterValue) {
                this.props.setFilterByPhrase(filterKey, filterValue, e);
            }
        } else {
            this.props.onToggleJsonDataCb(e);
        }
    }

    goTo = (e) => {
        let log = this.props.log;
        this.props.goToCb({ line: log.line, file: log.file, scriptsHash: log.scriptsHash });
        cancelEvent(e);
    }

    isJsonEmpty = (jsonInStr) => {
        return _.isEmpty(JSON.parse(jsonInStr));
    }

    showScreenshotPreview = (e) => {
        const {
            log,
            showBigLogImage
        } = this.props;

        showBigLogImage({ url: getResourceLink(log.screenshotLink) });
        cancelEvent(e);
    }

    openGraph = (e) => {
        const {
            log,
            environment
        } = this.props;

        const project = store.getState().projectsInfo.currentProject;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Provider store={store}>
                        <Suspense fallback={<Loader theme={LoaderTheme.Light} size={LoaderSize.Big} center={true} />}>
                            <LogGraphPopup
                                projectId={project.projectId}
                                onClose={() => {
                                    onClose();
                                }}
                                environment={environment}
                                log={log}
                            />
                        </Suspense>
                    </Provider>
                );
            }
        });
        cancelEvent(e);
    }

    getMsg(arrOfObjs = []) {
        const { onJsonObjClick } = this.props;

        return <>
            {arrOfObjs.map((obj, ind) => {
                if (isJsonLogType(obj)) {
                    const parsedObj = JSON.parse(obj.value);
                    return <span onClick={() => onJsonObjClick(ind)} className="log-line-row_preview_json" key={ind}>
                        {Array.isArray(parsedObj)
                            ? this.isJsonEmpty(obj.value) ? '[]' : '[...]'
                            : this.isJsonEmpty(obj.value) ? '{}' : (parsedObj.event ? `{event: "${parsedObj.event}", ...}` : '{...}')}
                    </span>;
                }
                return <span className="log-line-row_preview_string" key={ind}>{obj.value}</span>;
            })}
        </>;
    }

    render() {
        let {
            log,
            showJsonData,
            title,
            maxLineLog,
            maxScriptNameWidth,
            hasAudioPreview,
            hasImagePreview,
            filters,
            intentLinkMode,
        } = this.props;

        if (_.isEmpty(log)) {
            return <div></div>;
        }

        let unrecognised = log.notFound;
        let isInput;
        let isOutput;
        let isError = log.level === logLevels.syntaxError || log.level === logLevels.runTimeError;
        let isInfo = log.level === logLevels.info;
        let isPhrase = log.level === logLevels.phrase;
        let msg = log.reason || log.phrase || this.getMsg(log.objects) || '';
        let logTs = +log.ts;

        const project = store.getState().projectsInfo.currentProject;
        const isShowGraph = phraseTypes[log?.type?.toLowerCase()] === phraseTypes.output && projectHelper.isSlu4_2(project) && isShowOpGraph(log);

        const isClickable = true;




        if (isPhrase) {
            isInput = phraseTypes[log.type.toLowerCase()] === phraseTypes.input;
            isOutput = phraseTypes[log.type.toLowerCase()] === phraseTypes.output;
        }

        return <div
            className={`log-line-row level-${log.level} ${log.new && 'new'} ${log.isWarning && 'warning'} ${isClickable && 'clickable'}`}
            onClick={isClickable ? this.onLogLineClick : undefined}>

            <div className={`log-line-row_fixed-left-part level-${log.level} ${(!log.file && !log.line) && 'without-file-info'}`} >
                {(isError && !log.isWarning) && <i className={`icon icon-alan-remove-sign log-type`} />}
                {(isInfo || log.isWarning) && <i className="icon icon-alan-info-sign log-type" />}
                {isPhrase &&
                    <i className={`icon log-type ${unrecognised && 'unrecognised'} ` + (isInput ? 'icon-alan-input-sign input-phrase-icon' : 'icon-alan-output-sign output-phrase-icon')} />}
                <div className="log-line-row_ts">
                    <div className="log-line-row_ts_date">{moment(logTs).format(formats.logTs_date)},</div>
                    <div className="log-line-row_ts_time">{moment(logTs).format(formats.logTs_time)}</div>
                </div>
            </div>
            <div className="log-line-row_flex-content">

                {typeof msg === 'object'
                    ? <div className={'log-line-row_msg'}>
                        {msg}
                    </div>
                    : <>
                        {log.entities?.length > 0 ?
                            <div
                                className={`log-line-row_msg ${isPhrase && 'bold'}`}
                                dangerouslySetInnerHTML={getContentWithChunks(escapeHtml(msg), log.entities, 'highlighted-text-in-logs', true, true, filters.entities)}
                            /> : <div className={`log-line-row_msg ${isPhrase && 'bold'}`}>
                                {msg}
                            </div>}
                    </>
                }

                <div className="log-line-row_fixed-right-part">
                    <div className="log-line-row_file-info">
                        {intentLinkMode === 'icon' ?
                            <i
                                className={`icon icon-alan-stat-script-link ${!log.line && 'invisible'}`}
                                onClick={log.line ? this.goTo : undefined} title={`${log.file}: ${log.line}`} /> :
                            <>
                                {(log.file || log.line > 0) &&
                                    <div className="log-line-row_file-info_nav-block">
                                        <div
                                            className={`log-line-row_file-info_nav-block_file-name`}
                                            style={{ minWidth: (log.intentAudioLink || log.screenshotLink || log.distance) ? `${maxScriptNameWidth}px` : 'initial' }}
                                            onClick={log.file ? this.goTo : undefined}>
                                            {log.file || ''}{log.line !== 0 && ':'}
                                        </div>
                                        {log.line > 0 && <div className={`log-line-row_file-info_nav-block_line line-length-${maxLineLog}`}
                                            onClick={log.line ? this.goTo : undefined}>
                                            {log.line || ''}
                                        </div>}
                                    </div>}
                                {(!log.file && (log.line <= 0 || !log.line)) &&
                                    <div className="log-line-row_file-info_nav-block">
                                        <div
                                            className={`log-line-row_file-info_nav-block_file-name`}
                                            style={{ minWidth: `${maxScriptNameWidth}px` }}>
                                            {log.file || ''}{log.line !== 0 && ':'}
                                        </div>
                                        <div className={`log-line-row_file-info_nav-block_line line-length-${maxLineLog}`} />
                                    </div>}
                            </>}
                        <div className="log-line-row_icons-holder">
                            {isInput && <>
                                {(!showJsonData) && <span title="Show screenshot"
                                    className={`log-line-row_file-info_screenshot-preview ${!log.screenshotLink && 'no-image'} ${hasImagePreview && 'with-image'}`}
                                    onClick={this.showScreenshotPreview}></span>}
                                {(!showJsonData) &&
                                    <div className={`log-line-row_file-info_audio-preview-holder ${!log.intentAudioLink && 'no-audio'} ${hasAudioPreview && 'with-audio'}`}>
                                        <PlayIntentAudioButton intentAudioLink={log.intentAudioLink} />
                                    </div>}
                            </>}
                            {isOutput && <>
                                {log.likeDislike === 1 &&
                                    <LikeIcon className="log-line-row_like-dislike-icon-wrapper" />
                                }
                                {log.likeDislike === -1 &&
                                    <DislikeIcon className="log-line-row_like-dislike-icon-wrapper" />
                                }
                                {isShowGraph ?
                                    <span onClick={this.openGraph} className="log-line-row_graph">
                                        <OpGraphLogIcon />
                                    </span> :
                                    <span className="log-line-row_graph"></span>
                                }
                            </>}
                        </div>

                        {(isPhrase && showJsonData) &&
                            <i className={`icon icon-alan-hide-more  phrase-arrow opened`}
                                onClick={this.props.onToggleJsonDataCb} />}
                        <i className={`icon icon-three-dots  phrase-arrow ${!isClickable && 'invisible'}`}
                            onClick={isClickable ? this.props.onToggleJsonDataCb : undefined} />
                    </div>
                </div>
            </div>
        </div>;
    }
}


function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showBigLogImage: (param) => dispatch(actions.showBigLogImage(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogLineRow);
